import React, { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';

const SERVER_URL = `${import.meta.env.VITE_REACT_APP_BASE_URL}`;
const ROOM_ID = 'room-1';
console.log('Connecting to server:', SERVER_URL);
const VideoCall = () => {
  const [socket, setSocket] = useState(null);
  const [otherUserId, setOtherUserId] = useState(null);
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const localStreamRef = useRef(null);
  const peerConnectionRef = useRef(null);

  useEffect(() => {
    const newSocket = io(SERVER_URL);
    setSocket(newSocket);

    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        localStreamRef.current = stream;
        if (localVideoRef.current) {
          localVideoRef.current.srcObject = stream;
        }
      })
      .catch((err) => {
        console.error('Failed to access camera/mic:', err);
      });

    return () => {
      newSocket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!socket) return;

    socket.emit('join-room', { roomId: ROOM_ID });

    socket.onAny((event, ...args) => {
      console.log(`Socket event: ${event}`, args);
    });

    socket.on('user-joined', ({ id }) => {
      console.log('User joined:', id);
      setOtherUserId(id);
      callUser(id);
    });

    socket.on('offer', async ({ offer, from }) => {
      console.log('Received offer from', from);
      setOtherUserId(from);
      await createPeerConnection(from);
      await peerConnectionRef.current.setRemoteDescription(new RTCSessionDescription(offer));

      const answer = await peerConnectionRef.current.createAnswer();
      await peerConnectionRef.current.setLocalDescription(answer);

      socket.emit('answer', { answer, to: from });
    });

    socket.on('answer', async ({ answer, from }) => {
      console.log('Received answer from', from);
      if (!peerConnectionRef.current) {
        await createPeerConnection(from);
      }
      await peerConnectionRef.current.setRemoteDescription(new RTCSessionDescription(answer));
    });

    socket.on('ice-candidate', async ({ candidate, from }) => {
      console.log('Received ICE candidate from', from);
      try {
        await peerConnectionRef.current.addIceCandidate(new RTCIceCandidate(candidate));
      } catch (error) {
        console.error('Error adding ICE candidate:', error);
      }
    });
  }, [socket]);

  const createPeerConnection = async (targetId) => {
    peerConnectionRef.current = new RTCPeerConnection();

    localStreamRef.current.getTracks().forEach((track) => {
      peerConnectionRef.current.addTrack(track, localStreamRef.current);
    });

    peerConnectionRef.current.ontrack = (event) => {
      console.log('Received remote track', event.streams);
      if (remoteVideoRef.current && event.streams[0]) {
        remoteVideoRef.current.srcObject = event.streams[0];
      }
    };

    peerConnectionRef.current.onicecandidate = (event) => {
      if (event.candidate && targetId) {
        console.log('Sending ICE candidate to', targetId);
        socket.emit('ice-candidate', {
          candidate: event.candidate,
          to: targetId,
        });
      }
    };
  };

  const callUser = async (userId) => {
    await createPeerConnection(userId);

    const offer = await peerConnectionRef.current.createOffer();
    await peerConnectionRef.current.setLocalDescription(offer);

    socket.emit('offer', { offer, to: userId });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', padding: '1rem' }}>
      <video
        ref={localVideoRef}
        autoPlay
        muted
        playsInline
        style={{ width: '400px', border: '2px solid green' }}
      />
      <video
        ref={remoteVideoRef}
        autoPlay
        playsInline
        style={{ width: '400px', border: '2px solid blue' }}
      />
    </div>
  );
};

export default VideoCall;
